/**
 * The following are the set of VC modules that all get loaded when landing 
 * on Explorer, History, Branches, and PullRequests pages.
 */ 
import "Build.Common/Scripts/Registration.Artifacts";
import "Engagement/Constants";
import "Engagement/Core";
import "Engagement/Dispatcher";
import "Engagement/Utils";
import "Presentation/Scripts/TFS/FeatureRef/FilteredListControl";
import "Presentation/Scripts/TFS/FeatureRef/FilteredListDropdownMenu";
import "Presentation/Scripts/TFS/FeatureRef/ListControl";
import "Presentation/Scripts/TFS/Generated/TFS.Discussion.Constants";
import "Presentation/Scripts/TFS/Generated/TFS.Server.WebAccess.WorkItemTracking.Constants";
import "Presentation/Scripts/TFS/Generated/TFS.WorkItemTracking.Constants";
import "Presentation/Scripts/TFS/TFS.Core.Utils";
import "Presentation/Scripts/TFS/TFS.Discussion.WebApi";
import "Presentation/Scripts/TFS/TFS.OM.Common";
import "react";
import "react-dom";
import "TFS/Core/Contracts";
import "TFS/VersionControl/Contracts";
import "VSS/Controls/Navigation";
import "VSS/Controls/PopupContent";
import "VSS/Performance";
import "VersionControl/Scripts/ChangeListType";
import "VersionControl/Scripts/ChangeListIdentityHelper";
import "VersionControl/Scripts/ChangesetArtifact";
import "VersionControl/Scripts/CommentParser";
import "VersionControl/Scripts/CommitArtifact";
import "VersionControl/Scripts/CommitIdHelper";
import "VersionControl/Scripts/Components/HeaderComponents/HeaderComponents";
import "VersionControl/Scripts/Controls/ChangesetSearchAdapter";
import "VersionControl/Scripts/Controls/CommitSearchAdapter";
import "VersionControl/Scripts/Controls/CreateRepositoryDialogShower";
import "VersionControl/Scripts/Controls/GitRepositorySelectorControl";
import "VersionControl/Scripts/Controls/GitRepositorySelectorMenu";
import "VersionControl/Scripts/Controls/LazyDialog";
import "VersionControl/Scripts/Controls/ShelvesetSearchAdapter";
import "VersionControl/Scripts/CustomerIntelligenceConstants";
import "VersionControl/Scripts/CustomerIntelligenceData";
import "VersionControl/Scripts/FileSpecUtility";
import "VersionControl/Scripts/Generated/TFS.VersionControl.Common";
import "VersionControl/Scripts/Generated/TFS.VersionControl.Legacy.Contracts";
import "VersionControl/Scripts/Generated/TFS.VersionControl.WebAccess.Contracts";
import "VersionControl/Scripts/GitClientService";
import "VersionControl/Scripts/GitItemFromJsonIsland";
import "VersionControl/Scripts/GitItemUtils";
import "VersionControl/Scripts/GitRefArtifact";
import "VersionControl/Scripts/GitRepositoryContext";
import "VersionControl/Scripts/PullRequestArtifact";
import "VersionControl/Scripts/RepositoryContext";
import "VersionControl/Scripts/Resources/TFS.Resources.VersionControl";
import "VersionControl/Scripts/TFS.VersionControl";
import "VersionControl/Scripts/TFS.VersionControl.Registration.Artifacts";
import "VersionControl/Scripts/TFS.VersionControl.VersionSpecs";
import "VersionControl/Scripts/TFS.VersionControl.WebApi";
import "VersionControl/Scripts/TfvcClientService";
import "VersionControl/Scripts/TfvcRepositoryContext";
import "VersionControl/Scripts/UsingWithStatusIndicator";
import "VersionControl/Scripts/VersionControlClientServiceBase";
import "VersionControl/Scripts/VersionControlPath";
import "VersionControl/Scripts/VersionControlRegistryPath";
import "VersionControl/Scripts/VersionControlUrls";
import "VersionControl/Scripts/Views/BaseView";